var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, nothing } from 'lit';
import { when } from 'lit/directives/when.js';
import { translate } from '../utilities/translate';
export const SdsLoadMoreBase = (Base) => {
    var _SdsLoadMoreBaseType_addLoadMore_accessor_storage, _SdsLoadMoreBaseType_addLoadAll_accessor_storage, _SdsLoadMoreBaseType_disableLoadMore_accessor_storage, _SdsLoadMoreBaseType_disableLoadAll_accessor_storage, _SdsLoadMoreBaseType_loadMoreInProgress_accessor_storage, _SdsLoadMoreBaseType_loadAllInProgress_accessor_storage, _SdsLoadMoreBaseType_loadedCount_accessor_storage, _SdsLoadMoreBaseType_count_accessor_storage;
    class SdsLoadMoreBaseType extends Base {
        constructor() {
            super(...arguments);
            _SdsLoadMoreBaseType_addLoadMore_accessor_storage.set(this, void 0);
            _SdsLoadMoreBaseType_addLoadAll_accessor_storage.set(this, void 0);
            _SdsLoadMoreBaseType_disableLoadMore_accessor_storage.set(this, void 0);
            _SdsLoadMoreBaseType_disableLoadAll_accessor_storage.set(this, void 0);
            _SdsLoadMoreBaseType_loadMoreInProgress_accessor_storage.set(this, void 0);
            _SdsLoadMoreBaseType_loadAllInProgress_accessor_storage.set(this, void 0);
            _SdsLoadMoreBaseType_loadedCount_accessor_storage.set(this, void 0);
            _SdsLoadMoreBaseType_count_accessor_storage.set(this, void 0);
        }
        static get properties() {
            return {
                addLoadMore: { type: Boolean, attribute: 'add-load-more' },
                addLoadAll: { type: Boolean, attribute: 'add-load-all' },
                disableLoadMore: { type: Boolean, attribute: 'disable-load-more' },
                disableLoadAll: { type: Boolean, attribute: 'disable-load-all' },
                loadMoreInProgress: { type: Boolean, attribute: 'load-more-in-progress' },
                loadAllInProgress: { type: Boolean, attribute: 'load-all-in-progress' },
                loadedCount: { type: Number, attribute: 'loaded-count' },
                count: { type: Number, attribute: 'count' },
            };
        }
        /** Shows the "Load More" button. @attr {boolean} add-load-more */
        get addLoadMore() { return __classPrivateFieldGet(this, _SdsLoadMoreBaseType_addLoadMore_accessor_storage, "f"); }
        set addLoadMore(value) { __classPrivateFieldSet(this, _SdsLoadMoreBaseType_addLoadMore_accessor_storage, value, "f"); }
        /** Shows the "Load All" button. @attr {boolean} add-load-all */
        get addLoadAll() { return __classPrivateFieldGet(this, _SdsLoadMoreBaseType_addLoadAll_accessor_storage, "f"); }
        set addLoadAll(value) { __classPrivateFieldSet(this, _SdsLoadMoreBaseType_addLoadAll_accessor_storage, value, "f"); }
        /** Disables the "Load More" button. @attr {boolean} disable-load-more */
        get disableLoadMore() { return __classPrivateFieldGet(this, _SdsLoadMoreBaseType_disableLoadMore_accessor_storage, "f"); }
        set disableLoadMore(value) { __classPrivateFieldSet(this, _SdsLoadMoreBaseType_disableLoadMore_accessor_storage, value, "f"); }
        /** Disables the "Load All" button. @attr {boolean} disable-load-all */
        get disableLoadAll() { return __classPrivateFieldGet(this, _SdsLoadMoreBaseType_disableLoadAll_accessor_storage, "f"); }
        set disableLoadAll(value) { __classPrivateFieldSet(this, _SdsLoadMoreBaseType_disableLoadAll_accessor_storage, value, "f"); }
        /** Shows a loading indicator in place of the "Load More" button. @attr {boolean} load-more-in-progress */
        get loadMoreInProgress() { return __classPrivateFieldGet(this, _SdsLoadMoreBaseType_loadMoreInProgress_accessor_storage, "f"); }
        set loadMoreInProgress(value) { __classPrivateFieldSet(this, _SdsLoadMoreBaseType_loadMoreInProgress_accessor_storage, value, "f"); }
        /** Shows a loading indicator in place of the "Load All" button. @attr {boolean} load-all-in-progress */
        get loadAllInProgress() { return __classPrivateFieldGet(this, _SdsLoadMoreBaseType_loadAllInProgress_accessor_storage, "f"); }
        set loadAllInProgress(value) { __classPrivateFieldSet(this, _SdsLoadMoreBaseType_loadAllInProgress_accessor_storage, value, "f"); }
        /** Number of items currently loaded (shown in the summary). @attr {number} loaded-count */
        get loadedCount() { return __classPrivateFieldGet(this, _SdsLoadMoreBaseType_loadedCount_accessor_storage, "f"); }
        set loadedCount(value) { __classPrivateFieldSet(this, _SdsLoadMoreBaseType_loadedCount_accessor_storage, value, "f"); }
        /** Total number of items (shown in the summary). @attr {number} count */
        get count() { return __classPrivateFieldGet(this, _SdsLoadMoreBaseType_count_accessor_storage, "f"); }
        set count(value) { __classPrivateFieldSet(this, _SdsLoadMoreBaseType_count_accessor_storage, value, "f"); }
        renderInfo() {
            return html `
                <div class="sds-load-more__loaded-info">
                    <span>${this.loadedCount}</span>
                    <bdi>${translate('sds.from')}</bdi>
                    ${this.count}
                </div>
            `;
        }
        renderButtons() {
            return html ` <div class="sds-load-more__row">
                ${when(this.addLoadMore, () => html `
                        <sds-button
                            library="system"
                            ?disabled="${this.disableLoadMore}"
                            ?loading="${this.loadMoreInProgress}"
                            loading-label="${translate('sds.loading')}"
                            class="sds-load-more__action"
                            @click="${() => this.dispatchLoadMore()}"
                            label="${translate('sds.load_more')}"
                            size="lg"
                            type="ghost"
                            icon="reset"
                        ></sds-button>
                    `, () => html ``)}
                ${when(this.addLoadAll, () => html `
                        <sds-button
                            library="system"
                            ?disabled="${this.disableLoadAll}"
                            ?loading="${this.loadAllInProgress}"
                            loading-label="${translate('sds.loading')}"
                            class="sds-load-more__action"
                            @click="${() => this.dispatchLoadAll()}"
                            label="${translate('sds.load_all')}"
                            size="lg"
                            type="ghost"
                            icon="refresh"
                        ></sds-button>
                        ${when(this.disableLoadAll && !this.loadMoreInProgress, () => html `<div class="sds-load-more__message">
                                ${translate('sds.disabled_load_all')}
                            </div>`, () => nothing)}
                    `, () => html ``)}
            </div>`;
        }
        dispatchLoadMore() {
            this.dispatchEvent(new CustomEvent(SdsLoadMoreBaseType.LOAD_MORE_CLICKED_EVENT, {
                detail: {
                    loadedCount: this.loadedCount,
                },
                bubbles: false,
                composed: false,
            }));
        }
        dispatchLoadAll() {
            this.dispatchEvent(new CustomEvent(SdsLoadMoreBaseType.LOAD_ALL_CLICKED_EVENT, {
                bubbles: false,
                composed: false,
            }));
        }
    }
    _SdsLoadMoreBaseType_addLoadMore_accessor_storage = new WeakMap(), _SdsLoadMoreBaseType_addLoadAll_accessor_storage = new WeakMap(), _SdsLoadMoreBaseType_disableLoadMore_accessor_storage = new WeakMap(), _SdsLoadMoreBaseType_disableLoadAll_accessor_storage = new WeakMap(), _SdsLoadMoreBaseType_loadMoreInProgress_accessor_storage = new WeakMap(), _SdsLoadMoreBaseType_loadAllInProgress_accessor_storage = new WeakMap(), _SdsLoadMoreBaseType_loadedCount_accessor_storage = new WeakMap(), _SdsLoadMoreBaseType_count_accessor_storage = new WeakMap();
    SdsLoadMoreBaseType.LOAD_MORE_CLICKED_EVENT = 'sds.load-more.clicked';
    SdsLoadMoreBaseType.LOAD_ALL_CLICKED_EVENT = 'sds.load-all.clicked';
    return SdsLoadMoreBaseType;
};
